"use strict";

var React = require('react');

module.exports = function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-dock-direction' + (props.disabled ? ' disabled' : '')),
    onMouseLeave: !props.disabled && props.onMouseLeave ? props.onMouseLeave : null,
    onMouseEnter: !props.disabled && props.onMouseEnter ? props.onMouseEnter.bind(null, props.value) : null
  });
};